// @ts-expect-error TS(7016)
import makeSubject from "callbag-subject";
import { all, call, put, takeEvery } from "redux-saga/effects";

import { ToastContent, getToastContent } from "constants/toasts";
import { ApiManager } from "services/api";
import * as SpamSerializer from "services/api/spam/spam-serializer";
import { ToastAutoHideDelay, ToastVariant, ToastsActions } from "store/features/toasts";
import { IActionWithPayload } from "store/helper";

import { RequestAction } from "../actions";

import { SpamActionNames, SpamActions } from "./actions";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* fetchBlockedList() {
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.spamApi.fetchBlocked);

  if (response.result) {
    yield put(SpamActions.fetchBlockedListSuccess({ values: response.result.map(SpamSerializer.deserializeEntry) }));
  } else {
    yield put(SpamActions.fetchBlockedListFailure({ error: "failed to fetch" }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* fetchTrustedList() {
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.spamApi.fetchTrusted);

  if (response.result) {
    yield put(SpamActions.fetchTrustedListSuccess({ values: response.result.map(SpamSerializer.deserializeEntry) }));
  } else {
    yield put(SpamActions.fetchTrustedListFailure({ error: "failed to fetch" }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* addBlockedEntry(action: IActionWithPayload<string, { entry: string }>) {
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.spamApi.addBlocked, action.payload.entry);

  if (response.result) {
    yield put(
      // @ts-expect-error TS(2345): Argument of type 'ISpamEntry | null' is not assign... Remove this comment to see the full error message
      SpamActions.addBlockedEntrySuccess(response.result ? SpamSerializer.deserializeEntry(response.result) : null)
    );
  } else {
    yield put(
      SpamActions.addBlockedEntryFailure({
        duplicated: response.responseStatus === 409,
        type: response.error.error.type,
      })
    );
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* addTrustedEntry(action: IActionWithPayload<string, { entry: string }>) {
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.spamApi.addTrusted, action.payload.entry);

  if (response.result) {
    yield put(
      // @ts-expect-error TS(2345): Argument of type 'ISpamEntry | null' is not assign... Remove this comment to see the full error message
      SpamActions.addTrustedEntrySuccess(response.result ? SpamSerializer.deserializeEntry(response.result) : null)
    );
  } else {
    yield put(
      SpamActions.addTrustedEntryFailure({
        type: response.error.error.type,
      })
    );
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* removeBlockedEntry(action: IActionWithPayload<string, { id: string }>) {
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.spamApi.removeBlocked, action.payload.id);

  if (response.result) {
    yield put(SpamActions.removeBlockedEntrySuccess());
  } else {
    yield put(SpamActions.removeBlockedEntryFailure());
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* removeTrustedEntry(action: IActionWithPayload<string, { id: string }>) {
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.spamApi.removeTrusted, action.payload.id);

  if (response.result) {
    yield put(SpamActions.removeTrustedEntrySuccess());
  } else {
    yield put(SpamActions.removeTrustedEntryFailure());
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* removeBlockedEntryFailure() {
  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.REMOVE_BLOCKED_ENTRY_FAILURE),
      variant: ToastVariant.Error,
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* removeTrustedEntryFailure() {
  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.REMOVE_TRUSTED_ENTRY_FAILURE),
      variant: ToastVariant.Error,
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* removeBlockedEntrySuccess() {
  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.REMOVE_BLOCKED_ENTRY_SUCCESS),
      variant: ToastVariant.Success,
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* removeTrustedEntrySuccess() {
  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.REMOVE_TRUSTED_ENTRY_SUCCESS),
      variant: ToastVariant.Success,
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* addTrustedEntrySuccess() {
  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.ADD_TRUSTED_ENTRY_SUCCESS),
      variant: ToastVariant.Success,
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* addBlockedEntrySuccess() {
  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.ADD_BLOCKED_ENTRY_SUCCESS),
      variant: ToastVariant.Success,
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* addTrustedEntryFailure(action: IActionWithPayload<string, { duplicated: boolean; type: string }>) {
  const { type } = action.payload;

  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.ADD_TRUSTED_ENTRY_FAILURE, { type }),
      variant: ToastVariant.Error,
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* addBlockedEntryFailure(action: IActionWithPayload<string, { type: string }>) {
  const { type } = action.payload;

  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.ADD_BLOCKED_ENTRY_FAILURE, { type }),
      variant: ToastVariant.Error,
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* queuedAddBlockedEntries(action: IActionWithPayload<string, { requesterEmails: string[] }>) {
  const { requesterEmails } = action.payload;

  const updateCalls = [];
  const progressChannel = makeSubject();

  yield put(
    ToastsActions.createToast({
      id: "QUEUED_BLOCKED_ENTRIES_TOAST",
      variant: ToastVariant.Success,
      content: getToastContent(ToastContent.QUEUED_BLOCKED_ENTRIES_PROGRESS, {
        progressChannel,
        count: requesterEmails.length,
      }),
      autoHideDelayTime: ToastAutoHideDelay.Infinite,
      removable: false,
    })
  );

  for (let i = 0; i < requesterEmails.length; i += 1) {
    const requesterEmail = requesterEmails[i];
    // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
    const response = yield call(ApiManager.spamApi.addBlocked, requesterEmail);
    progressChannel(1, {});
    updateCalls.push(response);
  }

  progressChannel(2);
  yield put(ToastsActions.removeToast({ id: "QUEUED_BLOCKED_ENTRIES_TOAST" }));
  const successCount = updateCalls.filter(r => r.result).length;
  const failureCount = updateCalls.filter(r => r.error && r.responseStatus !== 409).length;

  yield put(SpamActions.queuedAddBlockedEntriesDone(successCount, failureCount));
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* queuedAddTrustedEntries(action: IActionWithPayload<string, { requesterEmails: string[] }>) {
  const { requesterEmails } = action.payload;

  const updateCalls = [];
  const progressChannel = makeSubject();

  yield put(
    ToastsActions.createToast({
      id: "QUEUED_TRUSTED_ENTRIES_TOAST",
      variant: ToastVariant.Success,
      content: getToastContent(ToastContent.QUEUED_TRUSTED_ENTRIES_PROGRESS, {
        progressChannel,
        count: requesterEmails.length,
      }),
      autoHideDelayTime: ToastAutoHideDelay.Infinite,
      removable: false,
    })
  );

  for (let i = 0; i < requesterEmails.length; i += 1) {
    const requesterEmail = requesterEmails[i];
    // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
    const response = yield call(ApiManager.spamApi.addTrusted, requesterEmail);
    progressChannel(1, {});
    updateCalls.push(response);
  }

  progressChannel(2);
  yield put(ToastsActions.removeToast({ id: "QUEUED_TRUSTED_ENTRIES_TOAST" }));
  const successCount = updateCalls.filter(r => r.result).length;
  const failureCount = updateCalls.filter(r => r.error && r.responseStatus !== 409).length;

  yield put(SpamActions.queuedAddTrustedEntriesDone(successCount, failureCount));
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* queuedAddTrustedEntriesDone(
  action: IActionWithPayload<string, { successCount: number; failureCount: number }>
) {
  const { successCount, failureCount } = action.payload;

  if (successCount > 0) {
    yield put(
      ToastsActions.createToast({
        variant: ToastVariant.Success,
        content: getToastContent(ToastContent.QUEUED_TRUSTED_ENTRIES_PROGRESS_DONE, { successCount, failureCount }),
      })
    );
  } else {
    yield put(
      ToastsActions.createToast({
        variant: ToastVariant.Success,
        content: getToastContent(ToastContent.ADD_TRUSTED_ENTRY_SUCCESS),
      })
    );
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* queuedAddBlockedEntriesDone(
  action: IActionWithPayload<string, { successCount: number; failureCount: number }>
) {
  const { successCount, failureCount } = action.payload;

  if (successCount > 0) {
    yield put(
      ToastsActions.createToast({
        variant: ToastVariant.Success,
        content: getToastContent(ToastContent.QUEUED_BLOCKED_ENTRIES_PROGRESS_DONE, { successCount, failureCount }),
      })
    );
  } else {
    yield put(
      ToastsActions.createToast({
        variant: ToastVariant.Success,
        content: getToastContent(ToastContent.ADD_TRUSTED_ENTRY_SUCCESS),
      })
    );
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* spamSagas() {
  yield all([
    takeEvery(SpamActionNames.FETCH_BLOCKED_LIST[RequestAction.REQUEST], fetchBlockedList),
    takeEvery(SpamActionNames.FETCH_TRUSTED_LIST[RequestAction.REQUEST], fetchTrustedList),
    takeEvery(SpamActionNames.ADD_BLOCKED_ENTRY[RequestAction.REQUEST], addBlockedEntry),
    takeEvery(SpamActionNames.ADD_TRUSTED_ENTRY[RequestAction.REQUEST], addTrustedEntry),
    takeEvery(SpamActionNames.REMOVE_BLOCKED_ENTRY[RequestAction.REQUEST], removeBlockedEntry),
    takeEvery(SpamActionNames.REMOVE_TRUSTED_ENTRY[RequestAction.REQUEST], removeTrustedEntry),
    takeEvery(SpamActionNames.REMOVE_BLOCKED_ENTRY[RequestAction.FAILURE], removeBlockedEntryFailure),
    takeEvery(SpamActionNames.REMOVE_BLOCKED_ENTRY[RequestAction.SUCCESS], removeBlockedEntrySuccess),
    takeEvery(SpamActionNames.REMOVE_TRUSTED_ENTRY[RequestAction.SUCCESS], removeTrustedEntrySuccess),
    takeEvery(SpamActionNames.REMOVE_TRUSTED_ENTRY[RequestAction.FAILURE], removeTrustedEntryFailure),
    takeEvery(SpamActionNames.ADD_BLOCKED_ENTRY[RequestAction.SUCCESS], addBlockedEntrySuccess),
    takeEvery(SpamActionNames.ADD_TRUSTED_ENTRY[RequestAction.SUCCESS], addTrustedEntrySuccess),
    takeEvery(SpamActionNames.ADD_BLOCKED_ENTRY[RequestAction.FAILURE], addBlockedEntryFailure),
    takeEvery(SpamActionNames.ADD_TRUSTED_ENTRY[RequestAction.FAILURE], addTrustedEntryFailure),
    takeEvery(SpamActionNames.QUEUED_ADD_BLOCKED_ENTRIES, queuedAddBlockedEntries),
    takeEvery(SpamActionNames.QUEUED_ADD_TRUSTED_ENTRIES, queuedAddTrustedEntries),
    takeEvery(SpamActionNames.QUEUED_ADD_BLOCKED_ENTRIES_DONE, queuedAddBlockedEntriesDone),
    takeEvery(SpamActionNames.QUEUED_ADD_TRUSTED_ENTRIES_DONE, queuedAddTrustedEntriesDone),
  ]);
}
